module.exports = __webpack_public_path__ + "184b3e23b54bcd58ed1993bc76ba52bb.pdf";